import React from "react";
import { Box, Typography, Button, Grid, Skeleton } from "@mui/material";
import useNetworkStatus from "../../../../helper/NetworkStatus";

const Capstoneaimagic = () => {
  const { isOnline } = useNetworkStatus();

  return (
    <Box>
      {isOnline ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          marginTop={10}
        >
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Capstone AI Magic Gateway to your Capstone
          </Typography>
          <Button variant="contained" color="primary" size="large" disabled>
            Coming Soon
          </Button>
        </Box>
      ) : (
        <Box mt={6}>
          <Typography variant="h6" align="center" gutterBottom>
            You are currently offline. Please check your internet connection.
          </Typography>
          <Grid container spacing={3}>
            {[...Array(9)].map((_, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Skeleton variant="rectangular" height={180} animation="wave" />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default Capstoneaimagic;
